import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Container from 'common/Container';
import { useTheme } from '@material-ui/core/styles';

const Hero = ({ themeMode = 'light' }) => {
  const theme = useTheme();

  return (
    <Box>
      <Box marginBottom={2}>
        <Container
          sx={{
            backgroundImage:
              themeMode === 'dark'
                ? 'url(/images/logos/logo_white.PNG)'
                : 'url(/images/logos/logo_tnonetwork_black.png)',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundSize: 'contain',
            height: '16vh',
          }}
        />
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 600 }}
          variant="overline"
          color="textSecondary"
          align="center"
          display="block"
          gutterBottom
        >
          Propuesta Integral de Lanzamiento
        </Typography>
        <Box
          component={Typography}
          fontWeight={700}
          variant="h3"
          gutterBottom
          align="center"
          color={theme.palette.primary.main}
        >
          Atache & TNO Network
        </Box>
        <Typography
          variant="h6"
          component="p"
          color="textSecondary"
          align="center"
          sx={{ fontStyle: 'italic', mb: 3 }}
        >
          La Ciencia de la Belleza Europea | Vital Pharma en Venezuela
        </Typography>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            mb: 3,
          }}
        >
          <Box
            component="img"
            src="/images/logos/atache.webp"
            alt="Atache - Vital Pharma"
            sx={{
              width: 120,
              height: 120,
              objectFit: 'contain',
            }}
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
        </Box>
        <Box
          sx={{
            maxWidth: 720,
            mx: 'auto',
            py: 2,
            px: 2,
            borderRadius: 2,
            bgcolor: theme.palette.mode === 'dark' ? 'action.hover' : 'grey.50',
          }}
        >
          <Typography
            variant="h6"
            component="p"
            color="textSecondary"
            align="center"
            gutterBottom
          >
            <strong>El Concepto Estratégico: &quot;Belleza con Evidencia&quot;</strong>
          </Typography>
          <Typography variant="body1" color="textSecondary" align="center">
            En un mercado saturado de promesas superficiales, <strong>Atache</strong> llega a Venezuela para imponer el rigor de la ciencia. Basándonos en los <strong>90 años de trayectoria e innovación de Laboratorios Vital Pharma en Europa</strong>, esta alianza busca conectar con la mujer venezolana que prioriza su salud y estética, ofreciéndole resultados comprobables. &quot;Belleza con Evidencia&quot; no es solo un lema; es la garantía de que cada producto respaldado por TNO Network cumple con los más altos estándares de la dermocosmética internacional.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

Hero.propTypes = {
  themeMode: PropTypes.string,
};

export default Hero;
